import React from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from '@mui/material';
import { AuthenticationWrawperForError } from 'src/components/authenticationWrapperForError.js';

const Error = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const location = useLocation();

  /** Handler functions ----------------------- **/

  /** Function to navigate back -------------------- **/
  const handleTryAgain = () => {
    navigate("/login");
  }


  return (
    <AuthenticationWrawperForError>
      {location?.state?.error || "Something went wrong"}
      <Button className='mt-3' variant="contained" onClick={() => handleTryAgain()}>Try Again</Button>
    </AuthenticationWrawperForError>
  )
}

export default Error
